// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../store";

const useRewardDetailsData = () => {
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const geniusLevel = store.user.userInfo?.geniusLevel || 0;

  const airports = store.flightDetails?.flight?.segments?.map((segment) => {
    const arrivalAirport = {
      code: segment.arrivalAirport.code,
      type: segment.arrivalAirport.type,
      city: segment.arrivalAirport.city,
      country: segment.arrivalAirport.country
    };
    const departureAirport = {
      code: segment.departureAirport.code,
      type: segment.departureAirport.type,
      city: segment.departureAirport.city,
      country: segment.departureAirport.country
    };

    return {
      arrivalAirport,
      departureAirport
    };
  });

  return {
    geniusLevel,
    airports
  };
};

export default useRewardDetailsData;
